export default __webpack_public_path__ + "media/images/svg/fence-decor-d3b10981b4e8f4f88700a06d6098df5e.svg";